var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Preact from 'preact';
import * as SvgIcon from '../A_SvgIcon';
/** Made by opening the svg exported from figma and manually copying the relevant bits into an
 * SvgIcon (and removing fill so it obeys colour setting).
 * Please see https://mui.com/material-ui/icons/#svgicon
 */
export function CheckCircleIcon(props) {
    return (Preact.h(SvgIcon.Component, __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        Preact.h("g", { id: "CheckCircleOutline" },
            Preact.h("path", { id: "Vector", d: "M13.8251 6.31666L8.33342 11.8083L5.34175 8.825L4.16675 10L8.33342 14.1667L15.0001 7.5L13.8251 6.31666ZM10.0001 1.66666C5.40008 1.66666 1.66675 5.4 1.66675 10C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 10C18.3334 5.4 14.6001 1.66666 10.0001 1.66666ZM10.0001 16.6667C6.31675 16.6667 3.33341 13.6833 3.33341 10C3.33341 6.31666 6.31675 3.33333 10.0001 3.33333C13.6834 3.33333 16.6667 6.31666 16.6667 10C16.6667 13.6833 13.6834 16.6667 10.0001 16.6667Z" }))));
}
